// libs
import React, { memo } from 'react';
import cx from 'classnames';
// dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
import { tokens } from '@swiggy-private/dls-web-common/dist/components/tokens';
// constants
import { IconPencil } from '@/constants/icons/svg';
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
// styles
import styles from './EditButton.module.scss';
const EditButton = ({ onClick, label, className, disabled = false, }) => {
    return (React.createElement("button", { disabled: disabled, className: cx(styles.button, className), onClick: onClick },
        React.createElement(IconPencil, { className: styles.buttonIcon, fillColor: tokens.colors.orange1 }),
        React.createElement(Text, { variant: DlsFontVariants.button_Text_BT3, color: DlsColorTokens.primary }, label)));
};
export default memo(EditButton);
